export const LIGHT_THRESHOLD = 0.55;
export const VALID_HEX_COLOR_REGEX = /^#(?:[0-9a-f]{6})$/i;

export const isValidHexColor = color => VALID_HEX_COLOR_REGEX.test(color);

export function luminance(r, g, b) {
  const a = [r, g, b].map(function X(v) {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

export function contrast(rgb1, rgb2) {
  return (
    (luminance(rgb1[0], rgb1[1], rgb1[2]) + 0.05) /
    (luminance(rgb2[0], rgb2[1], rgb2[2]) + 0.05)
  );
}

export const hexToDecimal = hexString =>
  [hexString.slice(0, 2), hexString.slice(2, 4), hexString.slice(4, 6)].map(i =>
    parseInt(i, 16),
  );

/**
 * cheapRelativeLuminance - Cheaper implementation of relative luminance built to mimic
 * backend luminace alogrithm
 *
 * https://github.com/lessonly/lessonly/blob/210ee087aaddb342d4708c0e5e52ade6832da1ca/app/models/color.rb#L26
 *
 * @param {string} hex 6 string hex color minus the #
 *
 * @returns {number} 0 - 1.0 representing lightness of pass color
 */
export function cheapRelativeLuminance(hex) {
  const [r, g, b] = hexToDecimal(hex);

  return (Math.min(r, g, b) + Math.max(r, g, b)) / (2 * 255.0);
}

export function isColorLight(hex) {
  return cheapRelativeLuminance(hex) > LIGHT_THRESHOLD;
}
